import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { getFullPath } from 'src/app/lib/get-full-path';
import { HeaderItem, websiteHeaderStructure } from 'src/app/website-header-structure';
import { SvgComponent } from '../svg/svg.component';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { ButtonDirective } from '../../directives/button.directive';
import { NgFor, NgIf, NgClass, LowerCasePipe } from '@angular/common';

@Component({
    selector: 'app-website-desktop-menu',
    templateUrl: './website-desktop-menu.component.html',
    styleUrls: ['./website-desktop-menu.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        ButtonDirective,
        RouterLink,
        RouterLinkActive,
        ContextMenuComponent,
        NgClass,
        SvgComponent,
        LowerCasePipe,
    ],
})
export class WebsiteDesktopMenuComponent {
  menuStructure = websiteHeaderStructure;

  constructor(private route: ActivatedRoute) {}

  isActive(item: HeaderItem) {
    const route = getFullPath(this.route.snapshot);
    route[0] = '/' + route[0];
    return item.dropdown.items.some(item => {
      if (!item.link) return;
      return JSON.stringify(route) === JSON.stringify(item.link);
    });
  }
}
